/**
 * Datas e agrupamento das notificações — partilhados pela Central
 * (`pages/NotificationsPage`) e pelo painel do sino (`shell/PainelDeNotificacoes`,
 * SPEC-20261104-1219). Saíram da página para as duas listas falarem a mesma
 * língua ("há 2 horas", Hoje/Esta semana/Antes).
 */
const RELATIVE_FMT = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' })
const DATE_FMT = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })
const TIME_FMT = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' })

export const relativeLabel = (iso: string, now: number) => {
  const date = new Date(iso)
  const minutes = Math.round((date.getTime() - now) / 60_000)
  const absolute = Math.abs(minutes)
  if (absolute < 60) return RELATIVE_FMT.format(minutes, 'minute')
  if (absolute < 60 * 24) return RELATIVE_FMT.format(Math.round(minutes / 60), 'hour')
  if (absolute < 60 * 24 * 7) return RELATIVE_FMT.format(Math.round(minutes / (60 * 24)), 'day')
  return `${DATE_FMT.format(date)} às ${TIME_FMT.format(date)}`
}

export const exactLabel = (iso: string) => {
  const date = new Date(iso)
  return `${DATE_FMT.format(date)} às ${TIME_FMT.format(date)}`
}

const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()

export type GroupId = 'today' | 'week' | 'before'

export const GROUP_LABEL: Record<GroupId, string> = {
  today: 'Hoje',
  week: 'Esta semana',
  before: 'Antes',
}

export const groupOf = (iso: string, now: number): GroupId => {
  const time = new Date(iso).getTime()
  if (time >= startOfDay(new Date(now))) return 'today'
  if (time >= now - 7 * 24 * 60 * 60_000) return 'week'
  return 'before'
}
